var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02Diamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-8 -8 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    strokeWidth: 8,
    stroke: "black",
    points: "50 0, 85 50, 50 100, 15 50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Diamond);
export default __webpack_public_path__ + "static/media/02-diamond.593d2376d3b4369114872d185b73595b.svg";
export { ForwardRef as ReactComponent };